// @flow

import React from 'react';
import { Link } from 'react-router-dom';
import { List } from 'semantic-ui-react';

type Props = {
  syndicates: Array<any>
};

const SyndicateList = (props: Props) => {
  const { syndicates } = props;

  return (
    <div>
      {!syndicates.length ? (
        'No Syndicates'
      ) : (
        <List>
          {syndicates.map(({ id, name, memberId }) => (
            <List.Item key={id}>
              <Link to={memberId ? `/view/${memberId}` : `/${id}`}>{name}</Link>
            </List.Item>
          ))}
        </List>
      )}
    </div>
  );
};

export default SyndicateList;



// WEBPACK FOOTER //
// ./src/screens/SyndicateDashboard/components/SyndicateList.js